import React, { useState, useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import { InputItem, InputNumberItem, ModalItem } from "../../../../../Components/Items";

const valoresIniciales = { nombre: "", descripcion: "", orden: 0 };

//Alta y edición de un piso del hotel. Un piso es un lienzo: las habitaciones se dibujan con
//coordenadas relativas al piso al que pertenecen.
const ModalNivelHotel = ({ visible, onClose, empresaId, proyectoId, nivel, headersToken, onGuardado }) => {
  const [valores, setValores] = useState(valoresIniciales);
  const [guardando, setGuardando] = useState(false);

  const esEdicion = !!nivel;

  useEffect(() => {
    if (!visible) return;
    setValores(
      nivel
        ? { nombre: nivel.nombre || "", descripcion: nivel.descripcion || "", orden: nivel.orden || 0 }
        : valoresIniciales
    );
  }, [visible, nivel]);

  const actualizar = (cambios) => setValores((prev) => ({ ...prev, ...cambios }));

  const guardar = async () => {
    if (!valores.nombre) {
      message.warning("Captura un nombre para el piso");
      return;
    }
    setGuardando(true);
    try {
      const res = await axios.post(
        esEdicion ? "hoteleria/editarNivelHotel" : "hoteleria/agregarNivelHotel",
        esEdicion
          ? { empresaId, _id: nivel._id, ...valores }
          : { empresaId, proyectoId, ...valores },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success(esEdicion ? "Piso actualizado correctamente" : "Piso creado correctamente");
        onGuardado(res.data.nivelHotelId || nivel._id);
        onClose();
      } else {
        message.error(res.data.error || "No se pudo guardar el piso");
      }
    } catch (error) {
      console.error("Error al guardar el piso:", error);
      message.error("No se pudo guardar el piso");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <ModalItem
      title={esEdicion ? "Editar piso" : "Agregar piso"}
      visible={visible}
      onCancel={onClose}
      onOk={guardar}
      width={460}
      footer
      spinning={guardando}
      confirmLoading={guardando}
    >
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre</div>
        <InputItem
          value={valores.nombre}
          placeholder="Planta Baja, Piso 1, Torre Sur..."
          onChange={(e) => actualizar({ nombre: e.target.value })}
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Descripción (opcional)</div>
        <InputItem value={valores.descripcion} onChange={(e) => actualizar({ descripcion: e.target.value })} />
      </div>
      <div>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Orden en el selector</div>
        <InputNumberItem
          style={{ width: "100%" }}
          min={0}
          value={valores.orden}
          onChange={(valor) => actualizar({ orden: valor })}
        />
        <div style={{ color: "#8a93a6", fontSize: 12, marginTop: 4 }}>
          Se captura a mano porque el orden no se puede sacar del nombre: "Planta Baja" va antes de
          "Piso 1" pero alfabéticamente iría después.
        </div>
      </div>
    </ModalItem>
  );
};

export default ModalNivelHotel;
